<div class="row">
  <div class="col-md-12">
    <pr-input-column label="Titulaire du compte" [derrors]="derrors">
      <input formControlName="chequeAccountHolder" type="text" />
    </pr-input-column>
  </div>
  <div class="col-md-12">
    <pr-input-column label="Numéro de chèque" [derrors]="derrors">
      <input formControlName="chequeNumber" type="text" />
    </pr-input-column>
  </div>
  <div class="col-md-12">
    <pr-input-column label="Banque" [derrors]="derrors">
      <input formControlName="chequeBank" type="text" />
    </pr-input-column>
  </div>
</div>
